import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

// Stato di errore per le liste: mai mostrare "nessun risultato" quando la lettura è fallita.
export const LoadErrorBox = ({ onRetry, what = "i dati", testId = "load-error", className = "", compact = false }) => (
  <div className={`${compact ? "py-5" : "py-12"} px-6 text-center ${className}`} data-testid={testId}>
    <AlertTriangle size={compact ? 18 : 24} className="mx-auto mb-2 text-amber-500" />
    <div className="text-sm font-medium text-text-primary">Impossibile caricare {what}.</div>
    <div className="text-xs text-text-secondary mt-1">
      Il collegamento col server non ha risposto: è un problema temporaneo, i dati non sono andati persi.
    </div>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        data-testid={`${testId}-retry`}
        className="mt-3 inline-flex items-center gap-1.5 rounded-md border border-border bg-surface px-3 py-1.5 text-xs font-medium text-text-primary hover:bg-subtle transition-colors"
      >
        <RefreshCw size={12} /> Riprova
      </button>
    )}
  </div>
);

export default LoadErrorBox;
